// ########################################################################################################################
// ######################## DON'T COMMIT THIS FILE UNITL & UNLESS YOU'VE ADDED A NEW VARIABLE. ############################
// ########################################################################################################################

export const environment = {
  //Options
  production: true,

  /*If this Button is true regular scan regular button will be enable */
  ENABLE_REGULAR_SCAN: false,

  /*If this Button is true livestream features will be enable */
  ENABLE_LIVESTREAM_TAB: false,

  /*If this Button is true check callibration of callibration screen  will be enable */
  ENABLE_CHECK_CALIBARTION_BUTTON: true,
  
  /*system health screen status interval time */
  SYSTEM_HEALTH_STATUS_CHECK_INTERVAL: 2000,

  /*system health ideal screen on restart*/
  SYSTEM_HEALTH_IDEAL_SCREEN_ON_RESTART: 140000,

  ENABLE_SINGLE_RELAY : true,


  // Prod URLS

  AGGREGATOR_API_ENDPOINT: 'AGGREGATOR_API_ENDPOINT_VAR',
  APP_DIAGNOSTIC_ENDPOINT : 'APP_DIAGNOSTIC_ENDPOINT_VAR',
  CLIENT_API_ENDPOINT: 'CLIENT_API_ENDPOINT_VAR',
  DIMENSIONING_API_ENDPOINT: 'DIMENSIONING_API_ENDPOINT_VAR',
  CONSOLIDATION_API_ENDPOINT: 'CONSOLIDATION_API_ENDPOINT_VAR',
  SCAN_POLL_TIMEOUT: 'SCAN_POLL_TIMEOUT_VAR',
  SCAN_CARGO_LITE_ENABLED : 'SCAN_CARGO_LITE_ENABLED_VAR',
  SCAN_CARGO_LITE_AWB_SEARCH_ENABLED : 'SCAN_CARGO_LITE_AWB_SEARCH_ENABLED_VAR',  
  KIOSK_ENABLED : 'KIOSK_ENABLED_VAR',
  KIOSK_API_ENDPOINT : 'KIOSK_API_ENDPOINT_VAR',
  PIECEWISE_GUIDED_ENABLED : 'false',
  SINGLE_SCAN_MODE: 'SINGLE_SCAN_MODE_VAR',
  MULTI_SCAN_MODE: 'MULTI_SCAN_MODE_VAR',
  VOLUME_SCAN_MODE: 'VOLUME_SCAN_MODE_VAR',
  CONSOLIDATION_WEIGHT_MANDATORY : 'false',
  SCAN_CARGO_LEGACY_ENABLED : 'false',
  NOSQL_INTERCEPTOR: 'true',
  LABEL_PRINT_API_ENDPOINT : 'LABEL_PRINT_API_ENDPOINT_VAR',
  PRINT_AT_PROCESS : 'PRINT_AT_PROCESS_VAR',
  SHOW_TILT_STACK : 'SHOW_TILT_STACK_VAR',
  SHOW_VOLWGT : 'SHOW_VOLWGT_VAR',
  SHOW_PIECEWISE_WEIGHT: 'SHOW_PIECEWISE_WEIGHT_VAR',
  GPN_ENABLED : 'GPN_ENABLED_VAR',
  GPN_MAX_LENGTH : 'GPN_MAX_LENGTH_VAR',
  REPORT_DAYS_RETENTION : 'REPORT_DAYS_RETENTION_VAR',
  MESH_VOLUME_ENABLED : 'MESH_VOLUME_ENABLED_VAR',
  SYSTEMINFO_API_ENDPOINT: 'SYSTEMINFO_API_ENDPOINT_VAR',
  EDIT_WARNING_ENABLED : 'EDIT_WARNING_ENABLED_VAR',
  CERTIFIED_DISPLAY_ENABLED : 'CERTIFIED_DISPLAY_ENABLED_VAR',
  ENABLE_VERIFY_CALIBRATION : 'ENABLE_VERIFY_CALIBRATION_VAR',
  CALIBRATION_API_ENDPOINT: 'CALIBRATION_API_ENDPOINT_VAR',
  CONSOLIDATION_SCAN_ENABLED: 'true',
  ULD_SCANNING_MODE_ENABLED: 'ULD_SCANNING_MODE_ENABLED_VAR',
  AWB_CHARACTER_LENGTH: 'AWB_CHARACTER_LENGTH_VAR',
  CLOUD_ENABLE: 'CLOUD_ENABLE_VAR',
  CLOUD_QUEUE_STALE_DURATION: 'CLOUD_QUEUE_STALE_DURATION_VAR',
  SKID_REMOVAL_ENABLED: 'SKID_REMOVAL_ENABLED_VAR',
  DELETE_CARGO_ENABLED: 'DELETE_CARGO_ENABLED_VAR',
  AGGREGATE_PIECES: 'AGGREGATE_PIECES_VAR',
  
  //// nosql pipeline
  // AGGREGATOR_API_ENDPOINT: 'http://192.168.1.166/api/aggregator', //'http://192.168.1.64:5001/api',
  // APP_DIAGNOSTIC_ENDPOINT : 'http://192.168.1.166/ros',
  // CLIENT_API_ENDPOINT : 'http://192.168.1.166/api/cargo',
  // DIMENSIONING_API_ENDPOINT : 'http://192.168.1.166/api/dimensioning',
  // CONSOLIDATION_API_ENDPOINT: 'http://192.168.1.166/api/consolidation',
  // SCAN_POLL_TIMEOUT: '9000',
  // SYSTEMINFO_API_ENDPOINT: 'http://192.168.1.166/api/systeminfo',
  // CALIBRATION_API_ENDPOINT: 'http://192.168.1.166/api/calibration',
  // NOSQL_INTERCEPTOR : "true",
  // PIECEWISE_GUIDED_ENABLED : "false",
  // SCAN_CARGO_LEGACY_ENABLED : "false",
  // SCAN_CARGO_LITE_ENABLED : "true",
  // SCAN_CARGO_LITE_AWB_SEARCH_ENABLED : "false",
  // CONSOLIDATION_WEIGHT_MANDATORY : "false",
  // KIOSK_ENABLED : "false",
  // KIOSK_API_ENDPOINT : "http://192.168.1.64/kiosk",                                 
  // LABEL_PRINT_API_ENDPOINT : 'http://192.168.1.64:5008//api/peripherals/print',
  // PRINT_AT_PROCESS : "outbound,inventory",
  // SHOW_TILT_STACK : "true",
  // SHOW_VOLWGT : "true",
  // SHOW_PIECEWISE_WEIGHT: 'true',
  // GPN_ENABLED : "false",
  // GPN_MAX_LENGTH : "25",
  // REPORT_DAYS_RETENTION : 90,
  // MESH_VOLUME_ENABLED : "false",
  // EDIT_WARNING_ENABLED : "true",        
  // CERTIFIED_DISPLAY_ENABLED : "true",
  // ENABLE_VERIFY_CALIBRATION : "true",
  // CONSOLIDATION_SCAN_ENABLED : "true",
  // ULD_SCANNING_MODE_ENABLED : "false",
  // SINGLE_SCAN_MODE: "true",
  // MULTI_SCAN_MODE: "true",
  // VOLUME_SCAN_MODE: "true"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

